const RefreshIcon = () => {
  return (
    <svg className="refresh-icon" width="12" height="10" viewBox="0 0 12 10" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M11.0002 1.45337V4.18064H8.27295" stroke="#F9F9FB" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M1 8.7263V5.99902H3.72727" stroke="#F9F9FB" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M2.14091 3.7262C2.37144 3.07474 2.76324 2.49229 3.27976 2.03321C3.79627 1.57412 4.42067 1.25336 5.09468 1.10086C5.76869 0.948357 6.47034 0.96908 7.13418 1.16109C7.79801 1.35311 8.40239 1.71016 8.89091 2.19892L11 4.18074M1 5.99892L3.10909 7.98074C3.59761 8.46951 4.20199 8.82656 4.86582 9.01857C5.52966 9.21059 6.23131 9.23131 6.90532 9.07881C7.57933 8.9263 8.20373 8.60554 8.72024 8.14646C9.23676 7.68738 9.62856 7.10493 9.85909 6.45347" stroke="#F9F9FB" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  )
}

export default RefreshIcon